import React from 'react'
import PropTypes from 'prop-types'
import { omit, isFunction, isEmpty } from 'lodash-es'

const withFocus = (Component, props = {}) => {
  // delay prop - may be used when the field is inside modal or pops out from outside the screen
  // we can delay the focus so the field is already visible on the screen
  const { delay = 0 } = props

  class ComponentWithFocus extends React.Component {
    componentDidMount() {
      this.addFocus(() => {
        if (isEmpty(this.el)) {
          return
        }
        // since the input has value before the focus is added the cursor is at the beginning
        // remove, value and add it again so the cursor is placed at the end of the string
        const { value } = this.el
        this.el.value = ''
        this.el.value = value
      })
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      const { addFocus } = this.props

      // add focus only once when the prop change it's state
      if (nextProps.addFocus && !addFocus) {
        this.addFocus()
      }
    }

    addFocus(callback) {
      // push the focus in the queue otherwise it looses focus immediately
      setTimeout(() => {
        if (!isEmpty(this.el)) {
          this.el.focus()
        }

        if (isFunction(callback)) {
          callback()
        }
      }, delay)
    }

    render() {
      return (
        <Component
          {...omit(this.props, 'addFocus')}
          elementRef={(el) => {
            this.el = el
          }}
        />
      )
    }
  }

  ComponentWithFocus.propTypes = {
    addFocus: PropTypes.bool,
  }

  ComponentWithFocus.defaultProps = {
    addFocus: false,
  }

  return ComponentWithFocus
}

export default withFocus
